import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FichaDaObraService } from 'src/app/ficha-da-obra/service/ficha-da-obra.service';
import { ProfileDataService } from 'src/app/header/perfil-usuario/service/profile-data.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { SucessoComponent } from '../../sucesso/sucesso.component';

@Component({
  selector: 'app-reportar-erro',
  standalone: true,
  imports: [CommonModule, FormsModule, SucessoComponent],
  templateUrl: './reportar-erro.component.html',
  styleUrls: ['./reportar-erro.component.scss'],
})
export class ReportarErroComponent implements OnInit {
  taskDescription = '';
  sucesso = false;
  @Output() loading = new EventEmitter<boolean>();
  @Input() idObra: number | null = null;
  @Input() workName: string = '';
  @Input() moduleId: number | null = null;
  @Input() module: string = '';
  @Input() constructorId: number | null = null;
  @Input() constructorName: string = '';
  @Input() companyId: number | null = null;
  @Input() companyName: string = '';
  @Output() actionConfirmed = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  constructor(
    private _fichaDaObraService: FichaDaObraService,
    private _profileDataService: ProfileDataService,
    private readonly authService: AuthService,
  ) {}

  ngOnInit() {
    this._profileDataService.loadProfileData().subscribe();
  }

  continuar() {
    this.sucesso = false;
    this.actionConfirmed.emit();
   
  }

  reportarErro() {
    this.loading.emit(true);
    if (this.idObra && this.taskDescription) {
      const profileData = this._profileDataService.getProfileData();
      const userId = this.authService.userID;

      const data = {
        workId: this.idObra,
        workName: this.workName,
        moduleId: this.moduleId,
        module: this.module,
        constructorId: this.constructorId,
        constructorName: this.constructorName,
        message: this.taskDescription,
        userId: userId ? parseInt(userId) : null,
        userName: profileData?.name || '',
        userEmail: profileData?.email || '',
        userPhone: profileData?.phone || '',
        companyId: this.companyId ? Number(this.companyId) : null,
        companyName: this.companyName,
        options: null,
      };

     

      this._fichaDaObraService.reportErroAdmin(data).subscribe(
        () => {
          this.sucesso = true;
          this.loading.emit(false); 
        },
        (error) => {
          console.error('Erro ao reportar:', error);
          this.loading.emit(false); 
        }
      );
    } else {
      console.warn('Descrição ou ID da obra ausente.');
      this.loading.emit(false); 
    }
  }
}
